import { Injectable } from "@angular/core";
import { Http, Headers, URLSearchParams } from "@angular/http";
import 'rxjs/add/operator/toPromise';
import { environment } from "../../environments/environment";
import { AppService } from "../app.service";

@Injectable()

export class VersionService {

    apiUrl: String;
    jwt: String;
    constructor(private http: Http, private appService: AppService) {
        this.apiUrl = environment.apiUrl;
        this.jwt = appService.getJwt();
    }

    getAppList(filterParams: any) {
        const url = this.apiUrl + 'api/cms/app/list';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');

        const params = new URLSearchParams();
        params.append("page", filterParams.page);
        params.append("size", filterParams.size);
        return this.http.get(url, { headers, params })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    createApp(data: any) {
        const url = this.apiUrl + 'api/cms/app/create';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(data);
        return this.http.post(url, body, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    editApp(data: any) {
        const url = this.apiUrl + 'api/cms/app/edit';
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        const body = JSON.stringify(data);
        return this.http.put(url, body, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

    deleteApp(idApp: string) {
        const url = this.apiUrl + 'api/cms/app/delete/' + idApp;
        const headers = new Headers();
        headers.append('X-Authorization', 'Bearer ' + this.jwt);
        headers.append('Content-Type', 'application/json');
        return this.http.delete(url, { headers })
            .toPromise()
            .then(res => res.json())
            .then(resJson => resJson);
    }

}


// WEBPACK FOOTER //
// /build/client-cms/src/app/version/version.service.ts